<template>
  <div  :class="isInviteUrl? 'invite-iframe':'decline-iframe'" >
    <iframe
      :src="`https://${queryUrl}`"
      class="w-full h-full border-0"
    >
    </iframe>
  </div>
</template>

<script>
  export default {
    name: "Main",
    data() {
      return {
        queryUrl: ''
      };
    },
    created() {
      this.queryUrl = this.$route.query.url;
      this.$store.commit("SET_PAGE_TYPE", "alex-connect");
      this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
    },
    computed: {
      isInviteUrl() {
        const arr = this.queryUrl.split('/');
        if (arr[2] === 'decline') return false;
        return true;
      }
    },
  };
</script>
<style scoped>
  .invite-iframe {
    height: 1800px;
    margin-top: 6rem;
   }
  .decline-iframe {
    height: 500px;
    margin-top: 6rem;
   }
</style>
